import { StakeholderTypeEnum } from './../../../../../../shared/models/enums';
import { StakeholderService } from 'src/app/core/services/stakeholder.service';
import { StakeholderHelperService } from '@secca/core/services/stakeholder-helper.service';
import { ServiceOrderHoverExtensionComponent } from '@secca/case/components/case-plans/plan/service-order-hover/service-order-hover-extension-component';
import { MedicalAssessmentServiceOrderHoverComponent } from '@secca/case/components/case-plans/plan/service-order-hover/medical-assessment-service-order-hover/medical-assessment-service-order-hover.component';
import {ServiceTypeEnum} from '../../../../../../shared/models/enums';
import {CasePlansService} from './../../case-plans.service';
import {Component, Input, ViewChild} from '@angular/core';
import {ServiceOrderHoverModel} from './service-order-hover-model';
import {ColorGroupHtml} from '../service-order/color-group-enum';
import {ServiceOrderHelper} from '../service-order/service-order-helper';
import {CaseStakeholder} from '@secca/shared/models/caseStakeholder';
import {RegularFlightNonMedicalServiceOrderHoverComponent} from '@secca/case/components/case-plans/plan/service-order-hover/regular-flight-non-medical-service-order-hover/regular-flight-non-medical-service-order-hover.component';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '@secca/shared/decorators/auto-unsubscribe';

@Component({
    selector: 'app-service-order-hover',
    templateUrl: './service-order-hover.component.html',
    styleUrls: ['./service-order-hover.component.scss'],
    standalone: false
})
@AutoUnsubscribe
export class ServiceOrderHoverComponent {
  @Input() caseStakeholder: CaseStakeholder[];
  @Input() coordinatonCaseStakeholders: CaseStakeholder[];
  serviceOrderHoverModel: ServiceOrderHoverModel;
  topHoverOffset: number = 160;

  private serviceBorderColor;
  private serviceBackgroundColor;

  private hoverContentComponent: ServiceOrderHoverExtensionComponent;

  $hoverServiceSubscr: Subscription;

  @ViewChild(MedicalAssessmentServiceOrderHoverComponent)
  set medicalAssessmentServiceOrderHoverComponent(val: MedicalAssessmentServiceOrderHoverComponent) {
    this.setHoverContentComponent(val);
  }

  @ViewChild(RegularFlightNonMedicalServiceOrderHoverComponent)
  set regularFlightNonMedicalServiceOrderHoverComponent(val: RegularFlightNonMedicalServiceOrderHoverComponent) {
    this.setHoverContentComponent(val);
  }

  private setHoverContentComponent(val) {
    if (val) {
      this.hoverContentComponent = val;
    }
  }

  constructor(
    private casePlansService: CasePlansService,
    private stakeholderHelperService: StakeholderHelperService,
    private stakeholderService: StakeholderService
  ) {
    this.$hoverServiceSubscr = casePlansService.getHoverServiceOrder().subscribe(
      result => {
        this.serviceOrderHoverModel = result;
        if (result) {
          if(result.topHoverOffset !== undefined){
            this.topHoverOffset = result.topHoverOffset;
          }
          this.onRefresh();
        }
      },
      error => console.log(error)
    );
  }

  get serviceOrderTypeName() {
    if (this.serviceOrderHoverModel == null) {
      return '';
    }
    const serviceType = this.serviceOrderHoverModel.serviceOrder.type.replace(/_/g, ' ');
    if (serviceType != null) {
      return serviceType.toString();
    } else {
      return '';
    }
  }

  get ServiceTypeEnum() {
    return ServiceTypeEnum;
  }

  get serviceOrderHoverStyle(): any {
    if (this.serviceOrderHoverModel == null) {
      return null;
    }
    return {
      top: this.serviceOrderHoverModel.serviceTopPosition - this.topHoverOffset + 'px',
      // the first column width = 150px, margin = 4px, first lane gets it on the right, others on the left, the width of the hover = 296
      left:
        (this.serviceOrderHoverModel.serviceOrder.laneNumber === 0 ? this.serviceOrderHoverModel.serviceWidth - 4 : -296) +
        this.serviceOrderHoverModel.serviceLeftPosition +
        +150 +
        'px'
    };
  }

  get logoStyle(): any {
    if (this.serviceOrderHoverModel == null) {
      return null;
    }
    return {
      borderLeftColor: this.serviceBorderColor,
      backgroundColor: this.serviceBackgroundColor
    };
  }

  get imageStyle(): any {
    if (this.serviceOrderHoverModel == null) {
      return null;
    }
    return {
      backgroundColor: this.serviceBorderColor,
      backgroundImage: "url('../../../../../../assets/icons/" + this.serviceOrderHoverModel.serviceTypeIcon + "')"
    };
  }

  get arrowStyle(): any {
    if (this.serviceOrderHoverModel == null) {
      return null;
    }
    return {
      top: this.topHoverOffset + 4 + 'px'
    };
  }

  private onRefresh() {
    if (this.serviceOrderHoverModel.serviceOrder) {
      if (this.hoverContentComponent) {
        this.hoverContentComponent.onRefresh();
      }
      const serviceOrderHelper = new ServiceOrderHelper(this.serviceOrderHoverModel.serviceOrder, []);
      const colorGroupForType = serviceOrderHelper.colorGroupForType();
      this.serviceBackgroundColor = ColorGroupHtml.getBackgroundColor(colorGroupForType);
      this.serviceBorderColor = ColorGroupHtml.getBorderColor(colorGroupForType);
    }
  }

  private createLocalStakeholder(caseStakeholder: CaseStakeholder): any {
    let type = caseStakeholder.stakeholderType;
    if (caseStakeholder.coTraveller) {
      type = StakeholderTypeEnum.coTraveller;
    }
    return {
      firstName: caseStakeholder.person.firstName != null ? caseStakeholder.person.firstName : '',
      surname: caseStakeholder.person.surname != null ? caseStakeholder.person.surname : '',
      icon: '/assets/icons/' + this.stakeholderService.addIconToCaseStakeholder(type as StakeholderTypeEnum) + '.svg',
      gender: caseStakeholder.person.gender,
      age: caseStakeholder.person.age
    };
  }
}
